export const getHtmlText = (html) => html.replace(/<\/?[^>]+\/?>/g, '').trim();
//# sourceMappingURL=getHtmlText.js.map